// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b68107ca11bb37e71ff9188297de9bfed45441ff.chunk.bundle.js";
};